import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    FAQPageId: 49,
    FAQModules: null,
  },
  getters: {
    getFAQHtml: (state) => {
      if (state.FAQModules) {
        // concatenate all the html values for each cms module on the page.
        return state.FAQModules.modules.map((m) => m.moduleSettings[0].value).join('');
      }
    },
  },
  mutations: {
    setFAQModules(state, data) {
      state.FAQModules = data;
    },
  },
  actions: {
    fetchFAQ({
      commit, state, dispatch, getters, rootGetters,
    }) {
      // fetch the cms modules for the booking conditions page by id.
      const path = rootGetters['applinks/getLink']('page', state.FAQPageId).url;
      axios.get(`/cms/pages/modules/bypath?path=${path}`)
        .then((res) => {
          commit('setFAQModules', res.data);
        });
    },
  },
};
